import React from "react";
import { Navigate } from "react-router-dom";
import { routes } from "../../constants";

// Adding an area now happens in a modal on Area Management. Keep this route
// so old links/bookmarks land there, with the Add Area modal open.
const AreaManagementAddArea = () => {
  return (
    <Navigate to={routes.areaManagement} replace state={{ openAddArea: true }} />
  );
};

export default AreaManagementAddArea;
